import React from 'react'
import { Container, StyledBlockPresentation } from './LocationTabs.styled'
import { isNotPast } from '../../utils/isNotPast'
import NormalizeMedia from '../../utils/NormalizeMedia'
import BlockPresentation from '../BlockPresentation/BlockPresentation'
import LargeRectangleBlocs from '../LargeRectangleBlocs/LargeRectangleBlocs'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import { MainContainer } from '../../theme/mainContainer.styled'

const LocationTabs = ({activeTab, locale, className}) => {
  const highlights = activeTab?.largeRectangleBlocs?.filter(isNotPast) || null
  return (
    <Container className={className}>
      {activeTab?.blocTextHtml && activeTab?.blocTextHtml.content && (
        <MainContainer>
          <CKEditorContent html={activeTab?.blocTextHtml.content}/>
        </MainContainer>
      )}
      {(activeTab?.presentationBlocDocuments ||
          activeTab?.presentationBlocTextHtml ||
          activeTab?.presentationBlocTitle ||
          activeTab?.media
      ) && (
        <StyledBlockPresentation>
          {(activeTab?.presentationBlocDocuments ||
            activeTab?.presentationBlocTextHtml ||
            activeTab?.presentationBlocTitle) && (
            <BlockPresentation
              documents={activeTab?.presentationBlocDocuments}
              text={activeTab?.presentationBlocTextHtml}
              title={activeTab?.presentationBlocTitle}
            />
          )}
          {activeTab?.media && <div>{NormalizeMedia(activeTab.media)}</div>}
        </StyledBlockPresentation>)}
      {highlights && (
        <LargeRectangleBlocs largesRectangles={highlights} locale={locale}/>
      )}
    </Container>
  )
}

LocationTabs.propTypes = {}

export default LocationTabs


